import { render } from "./confirmModelForPreliminary.vue?vue&type=template&id=66845a6c"
import script from "./confirmModelForPreliminary.vue?vue&type=script&lang=js"
export * from "./confirmModelForPreliminary.vue?vue&type=script&lang=js"

import "./confirmModelForPreliminary.vue?vue&type=style&index=0&id=66845a6c&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__